import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const stInquiriesProofOfStudyList: ApiFunc<`${typeof API.ST_INQUIRIES_PROOF_OF_STUDY}`, 'get'> = data =>
  instance.get(API.ST_INQUIRIES_PROOF_OF_STUDY, {
    params: data,
  })

export const stInquiriesProofOfStudyCreate: ApiFunc<`${typeof API.ST_INQUIRIES_PROOF_OF_STUDY}`, 'post'> = data =>
  instance.post(API.ST_INQUIRIES_PROOF_OF_STUDY, data)
